import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-14">
            <div>
              <p className="text-primary-500 text-xs md:text-sm font-medium tracking-wider uppercase mb-2">分类浏览</p>
              <h3 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
                探索你喜欢的类型
              </h3>
            </div>
            <p className="text-foreground-500 text-sm max-w-xs">
              从浪漫恋爱到惊险悬疑，每一个分类都有你最爱的故事
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group relative overflow-hidden rounded-lg bg-background-50 p-5 md:p-6 flex flex-col items-center text-center transition-all hover:scale-[1.02] cursor-pointer"
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 rounded-full ${cat.color} flex items-center justify-center mb-4 transition-transform group-hover:scale-110`}>
                  <i className={`${cat.icon} text-white text-lg md:text-xl`}></i>
                </div>
                <h4 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {cat.name}
                </h4>
                <p className="text-foreground-400 text-xs">{cat.nameEn}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}